import React from 'react';

export const ForgePioGuruIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162.31 162.01">
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_1-2" data-name="Layer 1">
					<path
						d="M162.28,96.29c.57,20.21-8.19,35.32-25.42,45C113,154.76,87.31,162.83,59.56,162c-15.64-.5-28.15-8-36.35-21.09C7.51,115.82-.94,88.36.08,58.64.62,43,8.69,30.76,21.86,22.7,46.67,7.52,73.69-.9,103,.08c15.87.53,28.12,8.75,36.46,22.05C153.65,44.77,160.28,69.86,162.28,96.29Z"
						fill="#000"
					/>
					<path
						d="M92.34,111.57a31.72,31.72,0,0,1-18.88,1.08c-14.71-4-25.39-17.48-25.39-32.16a32.54,32.54,0,0,1,9.68-23.73,33,33,0,0,1,22.66-9.57h.31c15.52.17,25.36,11.89,25.44,12a3.86,3.86,0,0,0,6-4.87c-.49-.6-12.13-14.64-31.35-14.85a40.58,40.58,0,0,0-40.46,41c0,18.11,13.08,34.78,31.11,39.62a36.5,36.5,0,0,0,9.5,1.22,41,41,0,0,0,14-2.51c11.88-4.34,23.47-15.76,23.05-29a79,79,0,0,1-8.47,5.32C107.25,102.44,100,108.78,92.34,111.57Z"
						fill="#fff"
					/>
					<path
						d="M121.5,71.35a61.28,61.28,0,0,1-8.35,7.21c-5.16-5-13.38-7.42-19.33-7.42-4.86,0-8.59,1.28-11.07,3.79a10.21,10.21,0,0,0-2.91,7.49c.08,5.25,3.85,10.93,14.16,11.16,5.75.14,11.37-1.72,16.29-4.24a54,54,0,0,0,7-4.27,67.35,67.35,0,0,0,9.87-8.47,3.86,3.86,0,0,0-5.67-5.25ZM94.17,85.86c-3-.07-6.56-.74-6.61-3.56a2.55,2.55,0,0,1,.69-2c.55-.56,2-1.49,5.57-1.49a23.07,23.07,0,0,1,12.33,4A26.05,26.05,0,0,1,94.17,85.86Z"
						fill="#fff"
					/>
				</g>
			</g>
		</svg>
	);
};
